// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.url;

  getUserName(): string | null {
    return sessionStorage.getItem('userName');
  }
  getUserid(): string | null {
    return sessionStorage.getItem('id');
  }
  getUseremail(): string | null {
    return sessionStorage.getItem('useremail');
  }
  constructor(private http: HttpClient) {}
  
  isAuthenticated(): Observable<boolean> {
    const token = sessionStorage.getItem('token');
    return new Observable<boolean>((observer) => {
      if (token) {
        observer.next(true);
      } else {
        observer.next(false);
      }
      observer.complete();
    });
  }
  

  login(email: string, password: string): Observable<any> {
    const body = {
      email,
      password
    };
    return this.http.post<any>(this.apiUrl + 'api/auth/login', body);
  }
  getPhoneDetails(phoneNumber: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    const body = { phoneNumber };
    return this.http.post<any>(this.apiUrl + 'api/users/phone', body, { headers });
  }
  getTransactionLogs(userId: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = { id: userId };
    return this.http.post(this.apiUrl + 'api/users/transactionLog', body, { headers });
  }
  getsmslogs(phoneNumber: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = { phoneNumber };
    return this.http.post<any>(this.apiUrl + 'api/users/smsLog', body, { headers });
  }
  getActiveUser(userId: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = { id: userId };
    return this.http.post(this.apiUrl + 'api/users/userActiveDevices', body, { headers });
  }
  deactivateUserActiveDevices(selectedUserId: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = { id: selectedUserId };
    return this.http.post<any>(`${this.apiUrl}api/users/deactivateUserActiveDevices`, body, { headers });
  }
  Deactivateuser(selectedphoneId: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const body = { id: selectedphoneId };
    return this.http.put(this.apiUrl + 'api/users/deactivateUser', body, { headers });
  }
  changePassword(email: string, requestBody: { oldPassword: string; newPassword: string }): Observable<any> {
    // Retrieve the token from sessionStorage
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error('Token is not available in sessionStorage');
      throw new Error('Token is missing in sessionStorage');
    }
  
    // Set headers with Authorization token
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
  
    // Construct the request payload
    const body = {
      email: email,
      ...requestBody, // Spread requestBody fields into the main body
    };
  
    // Make the API call
    return this.http.post(`${this.apiUrl}api/users/change-password`, body, { headers });
  }
  

  logout(token:any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.post<any>(this.apiUrl + 'api/auth/logout', {}, { headers });
  }

  
}
